<template>
  <div class="register">
    <Banner
      :title="'REGISTER'"
      :class-banner="'common-banner'"
    />
    <div class="register__title">
      Please complete below form to register. All fields are mandatory
    </div>
    <div class="register__input-fullname register__input-common">
      <b-form-input
        type="text"
        v-model="fullName"
        placeholder="Full Name"
      />
    </div>
    <div class="register__input-cell-phone register__input-common">
      <b-input-group >
        <template #prepend>
          <b-input-group-text >{{callingCode}}</b-input-group-text>
        </template>
        <b-form-input
            type="number"
            v-model="phone"
            placeholder="Cellphone"
        />
      </b-input-group>
    </div>
    <div class="register__input-password register__input-common">
      <b-form-input
          type="password"
          v-model="password"
          placeholder="Password"
      />
    </div>
    <div class="register__button-register">
      <b-button @click="handleRegister">Register</b-button>
    </div>
    <div class="register__forgot-register">
      <div @click="$router.push('/forgot-password')" class="forgot-password-bottom">Forgot password</div>
      <div class="line">|</div>
      <div @click="$router.push('login')" class="login-bottom">Login</div>
    </div>
  </div>
</template>
<script>
import Banner from '@/components/common/banner';
import authService from '@/services/auth.service';
const CALLINGCODE = process.env.VUE_APP_CALLING_CODE;

export default {
  components: {
    Banner
  },
  data() {
    return {
      callingCode: "+" + CALLINGCODE,
      fullName: '',
      phone: '',
      password: ''
    }
  },
  methods: {
    handleRegister() {
      authService.register(this.fullName, this.phone, this.password).then((res) => {
        if (res.status === 'success') {
          this.$bvToast.toast('Register successfully', {
            title: 'Successfully',
            variant: 'success',
            solid: true,
            autoHideDelay: 5000
          });
          this.$router.push('/account');
        } else {
          const message = res.message;
          this.$bvToast.toast(message, {
            title: 'Failed',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          })
        }

      },
      () => this.$bvToast.toast('Register failed! Please try again', {
        title: 'Failed',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000
      }));
    }
  }
}
</script>
